import React from "react";
// import styled from "styled-components";
import Logo from "./fwdlook_logo.svg";

const defaultSize = "30px";
const FwdlookLogo = ({ size }) => (
  <img
    src={Logo}
    alt="FWDLOOK logo"
    width={size ? size : defaultSize}
    height={size ? size : defaultSize}
  />
);

export default FwdlookLogo;



// WEBPACK FOOTER //
// ./src/components/FwdlookLogo/index.js